import * as React from 'react';
import { clsx as cx } from 'clsx';

import { EPlatform } from '../../types/platform';
import { TFooterType } from '../../types/footerType';
import { AndroidIcon } from './icons/AndroidIcon';
import { AppleIcon } from './icons/AppleIcon';

import * as styles from './MobileFooter.css';

interface IMobileFooterProps {
  platform: EPlatform | null;
  type: TFooterType;
  withSiteTypeChanging: boolean;
  onSiteTypeChange(event: React.MouseEvent<HTMLAnchorElement>): void;
  onDownloadAppClick(event: React.MouseEvent<HTMLAnchorElement>, platform: EPlatform): void;
}

export const MobileFooter: React.FC<IMobileFooterProps> = params => {
  const { platform, type, withSiteTypeChanging, onSiteTypeChange, onDownloadAppClick } = params;
  // TODO сделать так чтобы на node и в браузере год всегда совпадал. Не нужно чтобы год зависел от настроек ОС пользака
  const year = new Date().getFullYear();

  return (
    <div className={cx(styles['c-footer-mobile'], type === 'adaptive' && styles['c-footer-mobile--adaptive'])}>
      <span className={styles['c-footer-mobile__copy']}>&copy; {year} ЦИАН ГРУПП</span>
      {withSiteTypeChanging && (
        <a href="/" className={styles['c-footer-mobile__full-link']} onClick={onSiteTypeChange}>
          Полная версия сайта
        </a>
      )}
      {platform === EPlatform.Android && (
        <a
          href="//play.google.com/store/apps/details?id=ru.cian.main"
          target="_blank"
          rel="nofollow noreferrer"
          data-mark="DownloadLinkGooglePlay"
          data-testid="DownloadLinkGooglePlay"
          className={styles['c-footer-mobile__store']}
          onClick={e => onDownloadAppClick(e, platform)}
        >
          <span className={styles['c-footer-mobile__os-icon-wrap']}>
            <AndroidIcon />
          </span>
          <span>Скачать приложение</span>
        </a>
      )}
      {platform === EPlatform.iOS && (
        <a
          href="//itunes.apple.com/app/id911804296"
          target="_blank"
          rel="nofollow noreferrer"
          data-mark="DownloadLinkAppStore"
          data-testid="DownloadLinkAppStore"
          className={styles['c-footer-mobile__store']}
          onClick={e => onDownloadAppClick(e, platform)}
        >
          <span className={styles['c-footer-mobile__os-icon-wrap']}>
            <AppleIcon />
          </span>
          <span>Скачать приложение</span>
        </a>
      )}
    </div>
  );
};
